import { gql } from '@apollo/client/core'

export interface OpeningHoursUpdateVariables {
  message: string
  addressId: number
}

export interface OpeningHoursUpdateResult {
  openingHoursUpdate: {
    result: string
  }
}

export const OPENING_HOURS_UPDATE = gql`
  mutation openingHoursUpdate($message: String!, $addressId: ID!) {
    openingHoursUpdate(message: $message, addressId: $addressId) {
      result
    }
  }
`

export const PARCEL_OPENING_HOURS_UPDATE = gql`
  mutation parcelOpeningHoursUpdate($message: String!, $addressId: ID!) {
    parcelOpeningHoursUpdate(message: $message, addressId: $addressId) {
      result
    }
  }
`

export const PARCEL_COLLECTION_HONORED_MUTATION = gql`
  mutation parcelCollectionHonored($parcelCollectionId: ID!) {
    parcelCollectionHonored(parcelCollectionId: $parcelCollectionId) {
      domiciliation {
        id
      }
    }
  }
`

export const PARCEL_COLLECTION_MISSED_MUTATION = gql`
  mutation parcelCollectionMissed($parcelCollectionId: ID!) {
    parcelCollectionMissed(parcelCollectionId: $parcelCollectionId) {
      domiciliation {
        id
      }
    }
  }
`

export const PARCEL_CANCEL_APPOINTMENT = gql`
  mutation parcelCancelAppointment($parcelCollectionId: ID!) {
    parcelCancelAppointment(parcelCollectionId: $parcelCollectionId) {
      result
    }
  }
`
